
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cbZqw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $awd1Q = parcelRequire("awd1Q");


var $7d2Nc = parcelRequire("7d2Nc");


var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $33344fa1a02cce50$export$2d0a3b8284ce9941 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.READ_TIME_SEGMENT_KEY)
});






var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $3IZob = parcelRequire("3IZob");


var $b3j2Y = parcelRequire("b3j2Y");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $h2uld = parcelRequire("h2uld");











var $lGgRw = parcelRequire("lGgRw");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");





var $gMc0m = parcelRequire("gMc0m");





var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");





var $x4n5k = parcelRequire("x4n5k");


var $6f0Oj = parcelRequire("6f0Oj");




var $b8XTE = parcelRequire("b8XTE");


var $luv00 = parcelRequire("luv00");





const $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    abbreviatedReadTime: {
        id: "read-time.by-line.abbreviated-estimated-read-time",
        defaultMessage: "{readTime} min"
    },
    readTime: {
        id: "read-time.by-line.estimated-read-time",
        defaultMessage: "{readTime} min read"
    },
    iconLabel: {
        id: "read-time.by-line.icon-label",
        defaultMessage: "Read time"
    },
    tooltipDescription: {
        id: "read-time.tooltip-description",
        defaultMessage: "Estimated read time"
    },
    wordCount: {
        id: "read-time.word-count",
        defaultMessage: "{wordCount} {wordCount, plural, one {word} other {words}}"
    }
});
const $cdcc5f8fb5019e0d$var$abbreviatedReadTimeStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    width: 'max-content',
    height: '24px'
});
const $cdcc5f8fb5019e0d$var$readTimeWithBulletStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex'
});
const $cdcc5f8fb5019e0d$var$baseStyledReadTime = null;
const $cdcc5f8fb5019e0d$var$detailsPanelStyledReadTime = null;
const $cdcc5f8fb5019e0d$var$underlineHoverStyles = (0, $ecnYn.xcss)({
    font: 'font.body',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $cdcc5f8fb5019e0d$var$abbreviatedReadTimeBadgeStyles = null;
const $cdcc5f8fb5019e0d$var$readTimeBullet = null;
function $cdcc5f8fb5019e0d$export$3e49eaea01c72fb7(t0) {
    const $ = (0, $frIzR.c)(21);
    const { pageId: pageId, readTime: readTime, isAbbreviatedReadTime: isAbbreviatedReadTime, isInEditor: isInEditor, isDetailsPanel: isDetailsPanel, wordCount: wordCount, showWordCount: showWordCount } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const useAbbreviatedReadTime = isAbbreviatedReadTime ?? (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline");
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isInEditor) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "displayed",
                    actionSubject: "tooltip",
                    actionSubjectId: "estimatedReadTime",
                    attributes: {
                        isInEditor: !!isInEditor
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isInEditor;
        $[2] = t1;
    } else t1 = $[2];
    const fireTooltipEvent = t1;
    let t2;
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== isInEditor || $[5] !== pageId || $[6] !== readTime) {
        t2 = ()=>{
            if (readTime) createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: "confluence-frontend",
                    action: "displayed",
                    actionSubject: "readTime",
                    actionSubjectId: pageId,
                    attributes: {
                        readTime: readTime,
                        isInEditor: !!isInEditor
                    }
                }
            }).fire();
        };
        t3 = [
            pageId,
            readTime,
            createAnalyticsEvent,
            isInEditor
        ];
        $[3] = createAnalyticsEvent;
        $[4] = isInEditor;
        $[5] = pageId;
        $[6] = readTime;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $42omo.useEffect)(t2, t3);
    const readTimeMessage = useAbbreviatedReadTime ? $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.abbreviatedReadTime : $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.readTime;
    const t4 = "read-time";
    const t5 = "read-time-component";
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            display: "inline-flex"
        };
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== formatMessage || $[11] !== isDetailsPanel || $[12] !== showWordCount || $[13] !== wordCount) {
        t7 = showWordCount && wordCount != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                isDetailsPanel && $cdcc5f8fb5019e0d$var$underlineHoverStyles
            ]
        }, formatMessage($cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.wordCount, {
            wordCount: wordCount
        }));
        $[10] = formatMessage;
        $[11] = isDetailsPanel;
        $[12] = showWordCount;
        $[13] = wordCount;
        $[14] = t7;
    } else t7 = $[14];
    const t8 = !!readTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            !useAbbreviatedReadTime && "_tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06azsu _p7f0u2gc",
            isDetailsPanel ? "_2hwxidpf _syazi7uo _1e0c1txw _4cvr1h6o _tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06i7uo _p7f01b66 _syay1b66" : "_2hwx1b66 _19bv12x7 _syazazsu",
            useAbbreviatedReadTime && "_2hwxze3t _19bv1b66 _u5f31b66 _80omtlke _4t3i1tcg _8vu412b0 _irr31dpa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.tooltipDescription),
        onShow: fireTooltipEvent,
        hideTooltipOnClick: true,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            useAbbreviatedReadTime ? $cdcc5f8fb5019e0d$var$abbreviatedReadTimeStyles : $cdcc5f8fb5019e0d$var$readTimeWithBulletStyles,
            isDetailsPanel && $cdcc5f8fb5019e0d$var$underlineHoverStyles
        ]
    }, useAbbreviatedReadTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))), {
        label: formatMessage($cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.iconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...readTimeMessage,
        values: {
            readTime: readTime
        }
    }))));
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
            metric: (0, $33344fa1a02cce50$export$2d0a3b8284ce9941)
        });
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== ssrPlaceholderIdProp || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": t4,
            "data-testid": t5,
            ...ssrPlaceholderIdProp,
            style: t6
        }, t7, t8, t9);
        $[16] = ssrPlaceholderIdProp;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
}
















var $6R5uz = parcelRequire("6R5uz");







var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");




var $cO1el = parcelRequire("cO1el");


var $9hlns = parcelRequire("9hlns");


var $2Yaht = parcelRequire("2Yaht");


var $6bJyJ = parcelRequire("6bJyJ");


var $9k33u = parcelRequire("9k33u");


var $fXbFR = parcelRequire("fXbFR");


var $gXrHX = parcelRequire("gXrHX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $4IoVL = parcelRequire("4IoVL");


var $cLo2u = parcelRequire("cLo2u");








var $jRNsq = parcelRequire("jRNsq");


var $gKr8t = parcelRequire("gKr8t");


var $bQm3c = parcelRequire("bQm3c");


var $eSUdr = parcelRequire("eSUdr");

const $9f801aec82aebb1e$export$56fc85c0a99a28b = (0, $eSUdr.default)`query LoomVideoDurationsQuery($id:ID!){loom_videoDurations(id:$id){sourceDuration playableDuration}}`;


const $818bfd9c5946b47f$export$31a19c7ba9f544b3 = ({ cloudId: cloudId, activationId: activationId, videoId: videoId })=>`ari:cloud:loom:${cloudId}:video/activation/${activationId}/${videoId}`;
const $818bfd9c5946b47f$export$7a511dab9d331a32 = (mediaFiles, collectionName)=>{
    const $ = (0, $frIzR.c)(9);
    const [mediaVideoDurations, setMediaVideoDurations] = (0, $42omo.useState)(0);
    const [isLoadingMediaDurations, setIsLoadingMediaDurations] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const mediaClient = (0, $jRNsq.useMediaClient)();
    let t0;
    let t1;
    if ($[0] !== collectionName || $[1] !== mediaClient || $[2] !== mediaFiles) {
        t0 = ()=>{
            let isMounted = true;
            const fetchDurations = async ()=>{
                if (!mediaFiles.length) {
                    setMediaVideoDurations(0);
                    setIsLoadingMediaDurations(false);
                    return;
                }
                setIsLoadingMediaDurations(true);
                try {
                    const durations = await mediaClient.file.getVideoDurations(mediaFiles.map((file)=>({
                            id: file,
                            collectionName: collectionName
                        })));
                    const totalDuration = Object.values(durations).reduce($818bfd9c5946b47f$var$_temp, 0);
                    if (isMounted) setMediaVideoDurations(totalDuration * 1000);
                } catch (t2) {
                    const err = t2;
                    if (isMounted) setError(err instanceof Error ? err : new Error("Unknown error"));
                }
                if (isMounted) setIsLoadingMediaDurations(false);
            };
            fetchDurations();
            return ()=>{
                isMounted = false;
            };
        };
        t1 = [
            mediaClient,
            mediaFiles,
            collectionName
        ];
        $[0] = collectionName;
        $[1] = mediaClient;
        $[2] = mediaFiles;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[5] !== error || $[6] !== isLoadingMediaDurations || $[7] !== mediaVideoDurations) {
        t2 = {
            mediaVideoDurations: mediaVideoDurations,
            isLoadingMediaDurations: isLoadingMediaDurations,
            error: error
        };
        $[5] = error;
        $[6] = isLoadingMediaDurations;
        $[7] = mediaVideoDurations;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
const $818bfd9c5946b47f$export$bad130a4e6ea861b = (videos)=>{
    const [loomVideoDurations, setLoomVideoDurations] = (0, $42omo.useState)(0);
    const [isLoadingLoomDurations, setIsLoadingLoomDurations] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const fetchAllDurations = async ()=>{
            if (!videos.length) {
                setIsLoadingLoomDurations(false);
                return;
            }
            setIsLoadingLoomDurations(true);
            setError(null);
            try {
                const client = (0, $gKr8t.getAGGClient)();
                let totalDuration = 0;
                for (const video of videos){
                    if (!isMounted) break;
                    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                    const response = await client.query({
                        query: (0, $9f801aec82aebb1e$export$56fc85c0a99a28b),
                        variables: {
                            id: $818bfd9c5946b47f$export$31a19c7ba9f544b3({
                                cloudId: cloudId,
                                activationId: activationId,
                                videoId: video.id
                            })
                        }
                    });
                    if (!isMounted) break;
                    if (response.data?.loom_videoDurations?.playableDuration) totalDuration += response.data.loom_videoDurations.playableDuration;
                }
                if (isMounted) {
                    setLoomVideoDurations(totalDuration * 1000);
                    setIsLoadingLoomDurations(false);
                }
            } catch (err) {
                if (isMounted) {
                    setError(err instanceof Error ? err : new Error('Unknown error'));
                    setIsLoadingLoomDurations(false);
                }
            }
        };
        fetchAllDurations();
        return ()=>{
            isMounted = false;
        };
    }, [
        videos,
        cloudId,
        activationId
    ]);
    return {
        loomVideoDurations: loomVideoDurations,
        isLoadingLoomDurations: isLoadingLoomDurations,
        error: error
    };
};
function $818bfd9c5946b47f$var$_temp(acc, duration) {
    return acc + duration;
}



var $72md5 = parcelRequire("72md5");

const $ea61e5b422419c5e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    readTime: {
        id: "read-time.read-time-popup",
        defaultMessage: "Read time break-down"
    },
    videos: {
        id: "read-time.read-time-popup-videos",
        defaultMessage: "Videos"
    },
    pageContent: {
        id: "read-time.read-time-popup-page-content",
        defaultMessage: "Page content"
    },
    expands: {
        id: "read-time.read-time-popup-expands",
        defaultMessage: "Expands"
    },
    expandTooltipDescription: {
        id: "read-time.read-time-popup-expand-tooltip-description",
        defaultMessage: "Loom videos and expands are excluded from read time estimates"
    },
    readTimeDisclaimer: {
        id: "read-time.read-time-popup-read-time-disclaimer",
        defaultMessage: "Not included in read time"
    }
});
const $ea61e5b422419c5e$var$popupStyles = (0, $ecnYn.xcss)({
    minWidth: '340px',
    position: 'relative',
    backgroundColor: 'elevation.surface.raised',
    border: `${"var(--ds-border-width, 1px)"} solid color.border`,
    borderRadius: 'radius.large',
    padding: 'space.250'
});
const $ea61e5b422419c5e$var$headingContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.050',
    marginBottom: 'space.200'
});
const $ea61e5b422419c5e$var$featureContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $ea61e5b422419c5e$var$lastFeatureContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.0'
});
const $ea61e5b422419c5e$var$baseIconStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.025',
    marginRight: 'space.100'
});
const $ea61e5b422419c5e$var$expandIconStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    width: '20px',
    height: '20px',
    marginLeft: 'space.negative.025',
    marginRight: 'space.075'
});
const $ea61e5b422419c5e$var$HorizontalDivider = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '1px',
    width: '135px'
});
const $ea61e5b422419c5e$var$formatVideoDuration = (ms)=>{
    const totalSeconds = Math.round(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    if (minutes === 0) return `${seconds} sec`;
    if (seconds === 0) return `${minutes} min`;
    return `${minutes} min ${seconds} sec`;
};
const $ea61e5b422419c5e$var$formatReadTimeInSeconds = (seconds)=>{
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    if (minutes === 0) return `${remainingSeconds} sec`;
    if (remainingSeconds === 0) return `${minutes} min`;
    return `${minutes} min ${remainingSeconds} sec`;
};
const $ea61e5b422419c5e$export$372a862ebf6e5d68 = ({ features: features, featuresSkipExpand: featuresSkipExpand, source: source, contentId: contentId = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readTimePopupRef = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(readTimePopupRef);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'readTime',
                    actionSubjectId: 'readTimePopup',
                    source: source,
                    attributes: {
                        dwellTime: getDwellTime()
                    }
                }
            }).fire();
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!features && !featuresSkipExpand) return null;
    let expandsReadTime = 0;
    if (features && featuresSkipExpand) {
        if (features.wordCount !== featuresSkipExpand.wordCount) expandsReadTime = (features.wordCount - featuresSkipExpand.wordCount) / 265 * 60;
    }
    const readTimeWithoutExpands = (featuresSkipExpand?.wordCount || 0) / 265 * 60;
    const pageContentReadTime = readTimeWithoutExpands + (0, $72md5.calculateImageReadTime)(featuresSkipExpand?.imageCount || 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: readTimePopupRef,
        testId: "read-time-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $ea61e5b422419c5e$var$popupStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        key: "readTime",
        xcss: [
            $ea61e5b422419c5e$var$featureContainerStyles,
            $ea61e5b422419c5e$var$headingContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ea61e5b422419c5e$export$a7357cdd1f0b0168.readTime)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        key: "wordCountSkipExpand",
        xcss: $ea61e5b422419c5e$var$featureContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ea61e5b422419c5e$var$baseIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
        color: "var(--ds-text-subtle, #505258)",
        label: formatMessage($ea61e5b422419c5e$export$a7357cdd1f0b0168.readTime)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ea61e5b422419c5e$export$a7357cdd1f0b0168.pageContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, $ea61e5b422419c5e$var$formatReadTimeInSeconds(pageContentReadTime)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        key: "readTimeDisclaimer",
        xcss: $ea61e5b422419c5e$var$featureContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ea61e5b422419c5e$export$a7357cdd1f0b0168.readTimeDisclaimer)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ea61e5b422419c5e$var$HorizontalDivider
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        key: "videoDuration",
        xcss: $ea61e5b422419c5e$var$featureContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ea61e5b422419c5e$var$baseIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
        color: "var(--ds-text-subtle, #505258)",
        label: formatMessage($ea61e5b422419c5e$export$a7357cdd1f0b0168.videos)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ea61e5b422419c5e$export$a7357cdd1f0b0168.videos)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea61e5b422419c5e$var$VideoDurations, {
        features: features,
        contentId: contentId
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        key: "expandsReadTime",
        xcss: [
            $ea61e5b422419c5e$var$featureContainerStyles,
            $ea61e5b422419c5e$var$lastFeatureContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $ea61e5b422419c5e$var$expandIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        color: "var(--ds-text-subtle, #505258)",
        label: formatMessage($ea61e5b422419c5e$export$a7357cdd1f0b0168.expands),
        spacing: "spacious",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ea61e5b422419c5e$export$a7357cdd1f0b0168.expands)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, $ea61e5b422419c5e$var$formatReadTimeInSeconds(expandsReadTime), " ")))));
};
const $ea61e5b422419c5e$var$VideoDurations = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { features: features, contentId: contentId } = t0;
    let t1;
    if ($[0] !== features?.looms) {
        t1 = features?.looms || [];
        $[0] = features?.looms;
        $[1] = t1;
    } else t1 = $[1];
    const { loomVideoDurations: loomVideoDurations, isLoadingLoomDurations: isLoadingLoomDurations } = (0, $818bfd9c5946b47f$export$bad130a4e6ea861b)(t1);
    let t2;
    if ($[2] !== contentId || $[3] !== features || $[4] !== isLoadingLoomDurations || $[5] !== loomVideoDurations) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea61e5b422419c5e$var$VideoDurationsWithMedia, {
            features: features,
            contentId: contentId,
            loomVideoDurations: loomVideoDurations,
            isLoadingLoomDurations: isLoadingLoomDurations
        });
        $[2] = contentId;
        $[3] = features;
        $[4] = isLoadingLoomDurations;
        $[5] = loomVideoDurations;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $ea61e5b422419c5e$var$VideoDurationsWithMedia = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { features: features, contentId: contentId, loomVideoDurations: loomVideoDurations, isLoadingLoomDurations: isLoadingLoomDurations } = t0;
    const [mediaClientConfig, setMediaClientConfig] = (0, $42omo.useState)(null);
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== isExternalShare || $[2] !== spaceKey) {
        t1 = ()=>{
            if (contentId) (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                mediaDspContentId: contentId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare
            }).then((t3)=>{
                const { viewMediaClientConfig: viewMediaClientConfig } = t3;
                return setMediaClientConfig(viewMediaClientConfig);
            }).catch($ea61e5b422419c5e$var$_temp);
        };
        t2 = [
            contentId,
            spaceKey,
            isExternalShare
        ];
        $[0] = contentId;
        $[1] = isExternalShare;
        $[2] = spaceKey;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    if (!mediaClientConfig) {
        let t3;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea61e5b422419c5e$var$CommonReadTimePopupSpinner, null);
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] !== contentId || $[7] !== features || $[8] !== isLoadingLoomDurations || $[9] !== loomVideoDurations) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea61e5b422419c5e$var$VideoDurationsContent, {
            features: features,
            contentId: contentId,
            loomVideoDurations: loomVideoDurations,
            isLoadingLoomDurations: isLoadingLoomDurations
        });
        $[6] = contentId;
        $[7] = features;
        $[8] = isLoadingLoomDurations;
        $[9] = loomVideoDurations;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== mediaClientConfig || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9k33u.MediaProvider), {
            mediaClientConfig: mediaClientConfig
        }, t3);
        $[11] = mediaClientConfig;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
};
const $ea61e5b422419c5e$var$VideoDurationsContent = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { features: features, contentId: contentId, loomVideoDurations: loomVideoDurations, isLoadingLoomDurations: isLoadingLoomDurations } = t0;
    let t1;
    if ($[0] !== features?.mediaFiles) {
        t1 = features?.mediaFiles || [];
        $[0] = features?.mediaFiles;
        $[1] = t1;
    } else t1 = $[1];
    const { mediaVideoDurations: mediaVideoDurations, isLoadingMediaDurations: isLoadingMediaDurations } = (0, $818bfd9c5946b47f$export$7a511dab9d331a32)(t1, `contentId-${contentId}`);
    if (isLoadingMediaDurations || isLoadingLoomDurations) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea61e5b422419c5e$var$CommonReadTimePopupSpinner, null);
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    const t2 = loomVideoDurations + mediaVideoDurations;
    let t3;
    if ($[3] !== t2) {
        t3 = $ea61e5b422419c5e$var$formatVideoDuration(t2);
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, t3);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
const $ea61e5b422419c5e$export$3b32eb2e03a92283 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).SMARTS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea61e5b422419c5e$export$372a862ebf6e5d68, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $ea61e5b422419c5e$var$CommonReadTimePopupSpinner = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $ea61e5b422419c5e$var$_temp() {}


const $b2726d89c406a12d$var$triggerStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    color: 'color.text',
    padding: 'space.0',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral.subtle'
});
const $b2726d89c406a12d$export$eb6727f1763071f3 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { contentId: contentId, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount, features: features, featuresSkipExpand: featuresSkipExpand, wordCount: wordCount, readTime: readTime, source: source } = t0;
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== isPopupOpen || $[3] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "readTime",
                    actionSubjectId: "readTimePopup",
                    source: source,
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            setIsPopupOpen(!isPopupOpen);
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = isPopupOpen;
        $[3] = source;
        $[4] = t1;
    } else t1 = $[4];
    const onPageReadTimeClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsPopupOpen(false);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== contentId || $[7] !== features || $[8] !== featuresSkipExpand || $[9] !== source) {
        t3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea61e5b422419c5e$export$3b32eb2e03a92283), {
                ...props,
                features: features,
                featuresSkipExpand: featuresSkipExpand,
                source: source,
                contentId: contentId
            });
        $[6] = contentId;
        $[7] = features;
        $[8] = featuresSkipExpand;
        $[9] = source;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== contentId || $[12] !== isAbbreviatedReadTime || $[13] !== isDetailsPanel || $[14] !== onPageReadTimeClick || $[15] !== readTime || $[16] !== showWordCount || $[17] !== wordCount) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                ...triggerProps,
                onClick: onPageReadTimeClick,
                xcss: $b2726d89c406a12d$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdcc5f8fb5019e0d$export$3e49eaea01c72fb7), {
                readTime: readTime,
                wordCount: wordCount,
                pageId: contentId,
                isAbbreviatedReadTime: isAbbreviatedReadTime,
                isDetailsPanel: isDetailsPanel,
                showWordCount: showWordCount
            }));
        $[11] = contentId;
        $[12] = isAbbreviatedReadTime;
        $[13] = isDetailsPanel;
        $[14] = onPageReadTimeClick;
        $[15] = readTime;
        $[16] = showWordCount;
        $[17] = wordCount;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== isPopupOpen || $[20] !== t3 || $[21] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
            isOpen: isPopupOpen,
            onClose: t2,
            placement: "bottom-start",
            content: t3,
            trigger: t4
        });
        $[19] = isPopupOpen;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
};






var $h3vPv = parcelRequire("h3vPv");

const $80e642dbd56c6416$export$961bca700bc56c3 = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, editorApi: editorApi, showWordCount: showWordCount, isDetailsPanel: isDetailsPanel, isAbbreviatedReadTime: isAbbreviatedReadTime = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    const [features, setFeatures] = (0, $42omo.useState)(null);
    const [featuresSkipExpand, setFeaturesSkipExpand] = (0, $42omo.useState)(null);
    const fetchPolicy = (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline') ? 'cache-only' : 'cache-first';
    const readTimeQueryOptions = {
        variables: {
            contentId: contentId,
            ...(0, $9wGTI.fg)('cc_page_experiences_new_editor_byline') && {
                status: [
                    'current',
                    'draft'
                ]
            }
        }
    };
    const { data: data, loading: loading, error: error } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_readtimequery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $h2uld.ReadTimeQuery), readTimeQueryOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $h2uld.ReadTimeQuery), {
        ...readTimeQueryOptions,
        fetchPolicy: fetchPolicy
    });
    const adf = (0, $42omo.useMemo)(()=>(0, $72md5.getAdf)(data ?? undefined), [
        data
    ]);
    // Initialize readtime with preloaded data for SSR
    const [readTime, setReadTime] = (0, $42omo.useState)((0, $72md5.calculateEstimatedReadTime)(adf));
    const [wordCount, setWordCount] = (0, $42omo.useState)((0, $72md5.getWordCount)(adf));
    (0, $42omo.useEffect)(()=>{
        if (!createAnalyticsEvent || !adf || loading || error || !contentId) return;
        const contentType = data?.content?.nodes?.[0]?.type ?? '';
        createAnalyticsEvent((0, $72md5.getContentFeatureExtractedEventObject)({
            contentType: contentType,
            contentId: contentId,
            adf: adf,
            isInEditor: true
        })).fire();
    }, [
        contentId,
        loading,
        adf,
        data?.content?.nodes,
        error,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (adf && !loading && !error) {
            setWordCount((0, $72md5.getWordCount)(adf));
            setReadTime((0, $72md5.calculateEstimatedReadTime)(adf));
        }
    }, [
        adf,
        loading,
        error
    ]);
    const setReadTimeFromEditorState = (0, $42omo.useCallback)(async ()=>{
        if (editorApi) editorApi.core?.actions.requestDocument((doc)=>{
            setWordCount((0, $72md5.getWordCount)(doc));
            setReadTime((0, $72md5.calculateEstimatedReadTime)(doc));
            if (doc) {
                setFeatures((0, $h3vPv.extractContentFeatures)(doc));
                setFeaturesSkipExpand((0, $h3vPv.extractContentFeaturesSkipExpand)(doc));
            }
        });
    }, [
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        // Sometimes the ADF from the query is outdated if the byline is re-rendered quickly after a document change
        // So recalculate read time from the editor ADF when the editor is ready
        setReadTimeFromEditorState();
    }, [
        setReadTimeFromEditorState
    ]);
    const debouncedCalculateReadTime = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(setReadTimeFromEditorState, 5000), [
        setReadTimeFromEditorState
    ]);
    (0, $42omo.useEffect)(()=>{
        subscribeDocChange(debouncedCalculateReadTime);
        return ()=>unsubscribeDocChange(debouncedCalculateReadTime);
    }, [
        debouncedCalculateReadTime,
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (readTime || showWordCount && wordCount != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2726d89c406a12d$export$eb6727f1763071f3), {
        contentId: contentId,
        isAbbreviatedReadTime: isAbbreviatedReadTime,
        isDetailsPanel: isDetailsPanel,
        showWordCount: showWordCount,
        features: features,
        featuresSkipExpand: featuresSkipExpand,
        wordCount: wordCount,
        readTime: readTime,
        source: "editorReadTime"
    });
});





















const $70e8bb0fe98c8861$export$8b2e5877d9d93c3c = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentId: contentId, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { adf: adf, loading: loading, error: error, contentType: contentType, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = (0, $h2uld.useReadTime)(contentId);
    let t1;
    let t2;
    if ($[0] !== adf || $[1] !== contentId || $[2] !== contentType || $[3] !== createAnalyticsEvent || $[4] !== error || $[5] !== loading) {
        t1 = ()=>{
            if (!createAnalyticsEvent || !adf || loading || error || !contentId || !contentType) return;
            createAnalyticsEvent((0, $72md5.getContentFeatureExtractedEventObject)({
                contentType: contentType,
                contentId: contentId,
                adf: adf,
                isInEditor: false
            })).fire();
        };
        t2 = [
            contentId,
            loading,
            error,
            contentType,
            createAnalyticsEvent,
            adf
        ];
        $[0] = adf;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = createAnalyticsEvent;
        $[4] = error;
        $[5] = loading;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $42omo.useEffect)(t1, t2);
    if (error) {
        let t3;
        if ($[8] !== error) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[8] = error;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    if (readTime || showWordCount && wordCount !== null) {
        const t3 = wordCount ?? 0;
        let t4;
        if ($[10] !== contentId || $[11] !== features || $[12] !== featuresSkipExpand || $[13] !== isAbbreviatedReadTime || $[14] !== isDetailsPanel || $[15] !== readTime || $[16] !== showWordCount || $[17] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2726d89c406a12d$export$eb6727f1763071f3), {
                contentId: contentId,
                isAbbreviatedReadTime: isAbbreviatedReadTime,
                isDetailsPanel: isDetailsPanel,
                showWordCount: showWordCount,
                features: features,
                featuresSkipExpand: featuresSkipExpand,
                wordCount: t3,
                readTime: readTime,
                source: "originalReadTime"
            });
            $[10] = contentId;
            $[11] = features;
            $[12] = featuresSkipExpand;
            $[13] = isAbbreviatedReadTime;
            $[14] = isDetailsPanel;
            $[15] = readTime;
            $[16] = showWordCount;
            $[17] = t3;
            $[18] = t4;
        } else t4 = $[18];
        return t4;
    }
    return null;
};


const $8f3b07438f5b7ca3$export$b8f4317b9340dac0 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId, editorApi: editorApi, isInEditor: isInEditor, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            metric: (0, $33344fa1a02cce50$export$2d0a3b8284ce9941)
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== editorApi || $[3] !== isAbbreviatedReadTime || $[4] !== isDetailsPanel || $[5] !== isInEditor || $[6] !== showWordCount) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8f3b07438f5b7ca3$export$77dedcd16f070a20, {
            contentId: contentId,
            editorApi: editorApi,
            isInEditor: isInEditor,
            isAbbreviatedReadTime: isAbbreviatedReadTime,
            isDetailsPanel: isDetailsPanel,
            showWordCount: showWordCount
        }));
        $[1] = contentId;
        $[2] = editorApi;
        $[3] = isAbbreviatedReadTime;
        $[4] = isDetailsPanel;
        $[5] = isInEditor;
        $[6] = showWordCount;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $8f3b07438f5b7ca3$export$77dedcd16f070a20 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { contentId: contentId, editorApi: editorApi, isInEditor: isInEditor, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount } = t0;
    const { locale: locale } = (0, $awd1Q.getTranslation)();
    const shouldRenderReadTime = locale && locale.substring(0, 2).toLowerCase() === "en";
    if (!shouldRenderReadTime) return null;
    let t1;
    if ($[0] !== contentId || $[1] !== editorApi || $[2] !== isAbbreviatedReadTime || $[3] !== isDetailsPanel || $[4] !== isInEditor || $[5] !== showWordCount) {
        t1 = isInEditor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80e642dbd56c6416$export$961bca700bc56c3), {
            contentId: contentId,
            editorApi: editorApi,
            showWordCount: showWordCount,
            isDetailsPanel: isDetailsPanel,
            isAbbreviatedReadTime: isAbbreviatedReadTime
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70e8bb0fe98c8861$export$8b2e5877d9d93c3c), {
            contentId: contentId,
            isAbbreviatedReadTime: isAbbreviatedReadTime,
            isDetailsPanel: isDetailsPanel,
            showWordCount: showWordCount
        });
        $[0] = contentId;
        $[1] = editorApi;
        $[2] = isAbbreviatedReadTime;
        $[3] = isDetailsPanel;
        $[4] = isInEditor;
        $[5] = showWordCount;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["ReadTimeLoader"] = $8f3b07438f5b7ca3$export$b8f4317b9340dac0;
module.exports["ReadTime"] = $8f3b07438f5b7ca3$export$77dedcd16f070a20;

});

parcelRegister("3IZob", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $42omo.useRef)(new Set());
    const handleDocChange = (0, $42omo.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $42omo.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}
module.exports["useDocChangeContext"] = $10e4e925e54c9160$export$82deeccbd0ef6b25;
module.exports["withDocChangeContext"] = $10e4e925e54c9160$export$9747c97496f7b432;

});

parcelRegister("h2uld", function(module, exports) {

var $j25oo = parcelRequire("j25oo");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $8b6571c5cd7e604c$export$9a0a69714186a2dc = (0, $j25oo.default);
const $8b6571c5cd7e604c$export$bf3941b9bff5380a = (contentId, skipQuery)=>{
    const readTimeQueryOptions = {
        variables: {
            contentId: contentId
        },
        skip: skipQuery
    };
    const { data: data, loading: loading, error: error } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_readtimequery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($8b6571c5cd7e604c$export$9a0a69714186a2dc, readTimeQueryOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($8b6571c5cd7e604c$export$9a0a69714186a2dc, {
        ...readTimeQueryOptions,
        fetchPolicy: 'cache-only'
    });
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = (0, $42omo.useMemo)(()=>{
        const adfFromData = (0, $72md5.getAdf)(data ?? undefined);
        if (!adfFromData || loading || error || !contentId) return {
            readTime: null,
            wordCount: null,
            features: null,
            featuresSkipExpand: null
        };
        return {
            adf: adfFromData,
            readTime: (0, $72md5.calculateEstimatedReadTime)(adfFromData),
            wordCount: (0, $72md5.getWordCount)(adfFromData),
            features: (0, $h3vPv.extractContentFeatures)(adfFromData),
            featuresSkipExpand: (0, $h3vPv.extractContentFeaturesSkipExpand)(adfFromData)
        };
    }, [
        loading,
        error,
        data,
        contentId
    ]);
    const contentNode = data?.content?.nodes?.[0];
    const contentType = contentNode?.type;
    return {
        loading: loading,
        error: error,
        adf: adf,
        contentType: contentType,
        readTime: readTime,
        wordCount: wordCount,
        features: features,
        featuresSkipExpand: featuresSkipExpand
    };
};
module.exports["ReadTimeQuery"] = $8b6571c5cd7e604c$export$9a0a69714186a2dc;
module.exports["useReadTime"] = $8b6571c5cd7e604c$export$bf3941b9bff5380a;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<73e6f733cbfadb69e70ae427aebee2a1>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("72md5", function(module, exports) {

var $h3vPv = parcelRequire("h3vPv");

const $7a7682e083b4bc67$var$wpm = 265; // words per minute, inspired by Medium.com
const $7a7682e083b4bc67$var$minute = 60;
const $7a7682e083b4bc67$export$dbd433271872c208 = (imageCount)=>{
    let readTime = 0;
    for(let i = 0; i < imageCount; i++)readTime += Math.max(12 - i, 3);
    return readTime;
};
const $7a7682e083b4bc67$export$a44553c2ca45b9b3 = (adf)=>{
    if (adf) {
        const extractedFeatures = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
        const features = extractedFeatures;
        const readTime = (features.wordCount / $7a7682e083b4bc67$var$wpm * 60 + $7a7682e083b4bc67$export$dbd433271872c208(features.imageCount)) / $7a7682e083b4bc67$var$minute;
        if (readTime > 0.5) return Math.round(readTime);
    }
    return 0;
};
const $7a7682e083b4bc67$export$da369a1128d64cc6 = (response)=>{
    const representation = response?.content?.nodes?.[0]?.body?.dynamic?.representation;
    if (representation === 'atlas_doc_format') {
        const adfString = response?.content?.nodes?.[0]?.body?.dynamic?.value;
        if (adfString) try {
            return JSON.parse(adfString);
        } catch  {
            return null;
        }
    }
    return null;
};
const $7a7682e083b4bc67$export$d7ca718a8dbe1f35 = ({ contentType: contentType, contentId: contentId, adf: adf, isInEditor: isInEditor })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence-frontend',
            action: 'extracted',
            actionSubject: 'contentFeature',
            objectType: contentType,
            objectId: contentId,
            attributes: {
                ...(0, $h3vPv.extractContentFeatures)(adf),
                isInEditor: isInEditor
            }
        }
    });
const $7a7682e083b4bc67$export$dba3e2bcdbd49da4 = (adf)=>{
    if (!adf) return 0;
    const features = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return features.wordCount;
};
module.exports["calculateImageReadTime"] = $7a7682e083b4bc67$export$dbd433271872c208;
module.exports["calculateEstimatedReadTime"] = $7a7682e083b4bc67$export$a44553c2ca45b9b3;
module.exports["getAdf"] = $7a7682e083b4bc67$export$da369a1128d64cc6;
module.exports["getContentFeatureExtractedEventObject"] = $7a7682e083b4bc67$export$d7ca718a8dbe1f35;
module.exports["getWordCount"] = $7a7682e083b4bc67$export$dba3e2bcdbd49da4;

});

parcelRegister("h3vPv", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

// helper function to traverse ADF tree while skipping expand nodes
const $a8469c4e0ee76bb2$var$reduceSkipExpand = (node, reducer, initialValue)=>{
    // skip if this is an expand node
    if (node.type === 'expand' || node.type === 'nestedExpand') return initialValue;
    // process current node
    let result = reducer(initialValue, node);
    // process child nodes if they exist
    if (node.content) result = node.content.reduce((acc, child)=>$a8469c4e0ee76bb2$var$reduceSkipExpand(child, reducer, acc), result);
    return result;
};
const $a8469c4e0ee76bb2$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $a8469c4e0ee76bb2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $a8469c4e0ee76bb2$var$wordCount(node.text)
            };
        case 'media':
            return {
                ...currentValue,
                imageCount: currentValue.imageCount + 1,
                mediaFiles: node.attrs?.type === 'file' && node.attrs?.id ? currentValue.mediaFiles.concat(node.attrs.id) : currentValue.mediaFiles
            };
        case 'inlineExtension':
            return {
                ...currentValue,
                inlineMacroCount: currentValue.macroCount + 1
            };
        case 'extension':
            return {
                ...currentValue,
                macroCount: currentValue.macroCount + 1
            };
        case 'table':
            return {
                ...currentValue,
                tableCount: currentValue.tableCount + 1
            };
        case 'embedCard':
            const url = node.attrs?.url;
            if (!url.includes('loom')) return currentValue;
            const videoId = url?.split('/').pop().split('?')[0];
            return {
                ...currentValue,
                looms: videoId ? currentValue.looms.concat({
                    id: videoId,
                    url: url
                }) : currentValue.looms
            };
    }
    return currentValue;
};
const $a8469c4e0ee76bb2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$export$8e18062037dcc9dd = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return $a8469c4e0ee76bb2$var$reduceSkipExpand(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $a8469c4e0ee76bb2$export$a148305df2eb5487;
module.exports["extractContentFeaturesSkipExpand"] = $a8469c4e0ee76bb2$export$8e18062037dcc9dd;

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("42omo")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("au4KV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $cgtv4.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("i1vUz", function(module, exports) {

var $4qmCZ = parcelRequire("4qmCZ");


var $8SLNj = parcelRequire("8SLNj");


var $8G3G6 = parcelRequire("8G3G6");


var $8uM2K = parcelRequire("8uM2K");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $h2uld = parcelRequire("h2uld");

const $649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery = (0, $8G3G6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $8SLNj.default);
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType, isRefreshRovoButton = false)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery, {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $jMyy4.useQueryInterop)((0, $4qmCZ.default), {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !isRovoButtonEnabled,
        fetchPolicy: 'network-only'
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    // Guard against cases where lastViewedTime would otherwise cause a NaN parse result
    const cleanedLastViewedTime = lastViewedTime.replace(/\[.*?\]$/, '');
    const parsedLastViewedTime = Date.parse(cleanedLastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const isFirstTimeVisit = Number.isNaN(parsedLastViewedTime);
    const lastViewedDate = isFirstTimeVisit ? undefined : new Date(parsedLastViewedTime);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading || readTimeLoading;
    let showCatchupAsDefault = false;
    let showSummarizeAsDefault = true;
    if (!parsedLastViewedTime && !isFirstTimeVisit || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading,
        queryError: queryError
    };
    if (isRovoButtonEnabled && pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && isFirstTimeVisit && readTime && readTime >= 5 && !isCurrentUserARecentCollaborator) {
        if (isRefreshRovoButton) return {
            showCatchupAsDefault: showCatchupAsDefault,
            showSummarizeAsDefault: showSummarizeAsDefault,
            readTime: readTime,
            queryLoading: queryLoading
        };
    }
    showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    showSummarizeAsDefault = false;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        showSummarizeAsDefault: showSummarizeAsDefault,
        queryLoading: queryLoading,
        lastViewedDate: lastViewedDate
    };
};
module.exports["useDynamicSplitButton"] = $649e6d4fa880ffb0$export$ca7c63318c849d7a;

});

parcelRegister("4qmCZ", function(module, exports) {
/**
 * @generated SignedSource<<6462f78220074fa59bcd7a2bc6f29acf>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37
const $3f3bb2f2b7df90db$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
            "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
            "metadata": {},
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
        }
    };
}();
$3f3bb2f2b7df90db$var$node.hash = "cb78a829ad38a06c36dc9615c22411b7";
var $3f3bb2f2b7df90db$export$2e2bcd8739ae039 = $3f3bb2f2b7df90db$var$node;
module.exports["default"] = $3f3bb2f2b7df90db$export$2e2bcd8739ae039;

});

parcelRegister("8SLNj", function(module, exports) {
/**
 * @generated SignedSource<<a9786bc227d6709215149cb341e9351f>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190
const $a7452eae54a23656$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "PaginatedContentHistoryList",
            "kind": "LinkedField",
            "name": "contentHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentHistory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ContributorUsers",
                            "kind": "LinkedField",
                            "name": "collaborators",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "userAccountIds"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
            "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
            "metadata": {},
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
        }
    };
}();
$a7452eae54a23656$var$node.hash = "428e55c833e4f9ecc04af6435214d702";
var $a7452eae54a23656$export$2e2bcd8739ae039 = $a7452eae54a23656$var$node;
module.exports["default"] = $a7452eae54a23656$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ReadTime.b407981e.js.map
